import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeUnmount, ref, watch } from 'vue'

  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import ExpandableTextAreaInput from '@/components/common/ExpandableTextAreaInput.vue'

  import useIcons from '@/composables/useIcons'
  import useCourse from '@/composables/useCourse'
  import useGamification from '@/composables/useGamification'
  import useSegment from '@/composables/useSegment'

  import CourseApi from '@/services/api/CourseApi'

  import type { Note } from '@/services/interfaces/Course'

  import { DateTime } from 'luxon'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Notes',
  setup(__props) {

  const { checkmark } = useIcons()
  const { trackGamificationActivity } = useGamification()
  const { currentCourseId, moduleId, lessonId, setLessonHasNote, course, currentModule, currentLesson } = useCourse()
  const { lessonNoteSaved } = useSegment()

  const myNotes = ref({ id: '', content: '', updatedAt: '' } as Note)
  const isSavingNotes = ref(false)
  const noteSaved = ref(false)
  const typedNotes = ref('')
  const timeoutId = ref<NodeJS.Timeout | undefined>(undefined)

  CourseApi.getLessonNote(currentCourseId.value, moduleId.value, lessonId.value).then((note) => {
    if (note) {
      myNotes.value = note
      typedNotes.value = note.content
    }
  })

  const showSaveButton = computed(() => typedNotes.value !== myNotes.value.content)

  const updatedDate = computed(() => {
    if (!myNotes.value.updatedAt) return null
    const d = DateTime.fromSQL(myNotes.value.updatedAt)
    return d.toFormat('dd.MM.yyyy')
  })

  const saveNotes = () => {
    if (isSavingNotes.value) return

    isSavingNotes.value = true
    CourseApi.saveLessonNote(currentCourseId.value, moduleId.value, lessonId.value, typedNotes.value)
      .then((note) => {
        if (!myNotes.value.id) {
          trackGamificationActivity('LESSON_NOTES_ADDED', {
            courseId: currentCourseId.value,
            moduleId: moduleId.value,
            lessonId: lessonId.value,
          })
        }

        lessonNoteSaved(
          currentCourseId.value,
          course.value!.title,
          moduleId.value,
          currentModule.value.name,
          lessonId.value,
          currentLesson.value!.title,
        )

        myNotes.value = note
        noteSaved.value = true
        setLessonHasNote(lessonId.value)
        setTimeout(() => {
          noteSaved.value = false
        }, 5000)
      })
      .finally(() => {
        isSavingNotes.value = false
      })
  }

  watch(typedNotes, () => {
    if (!noteSaved.value && showSaveButton.value) {
      clearTimeout(timeoutId.value)

      timeoutId.value = setTimeout(() => {
        saveNotes()
      }, 2500)
    }
  })

  onBeforeUnmount(() => {
    clearTimeout(timeoutId.value)
  })

return { __sfc: true,checkmark, trackGamificationActivity, currentCourseId, moduleId, lessonId, setLessonHasNote, course, currentModule, currentLesson, lessonNoteSaved, myNotes, isSavingNotes, noteSaved, typedNotes, timeoutId, showSaveButton, updatedDate, saveNotes, computed, onBeforeUnmount, ref, watch, LoadingSpinner, KetchUpButton, SVGRenderer, ExpandableTextAreaInput, useIcons, useCourse, useGamification, useSegment, CourseApi, DateTime }
}

})